import { render, staticRenderFns } from "./events-redirect.vue?vue&type=template&id=24e266f4&scoped=true&"
import script from "./events-redirect.vue?vue&type=script&lang=js&"
export * from "./events-redirect.vue?vue&type=script&lang=js&"
import style0 from "./events-redirect.vue?vue&type=style&index=0&id=24e266f4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e266f4",
  null
  
)

export default component.exports